import { render, staticRenderFns } from "./PageStructure.vue?vue&type=template&id=be1943a4"
import script from "./PageStructure.vue?vue&type=script&lang=js"
export * from "./PageStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports